import { render, staticRenderFns } from "./AppHeaderWithSubtitle.vue?vue&type=template&id=681f8e1d&"
import script from "./AppHeaderWithSubtitle.vue?vue&type=script&lang=js&"
export * from "./AppHeaderWithSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderWithSubtitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
